/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = require("webpack-core/lib/SourceMapSource");



//////////////////
// WEBPACK FOOTER
// (webpack)/lib/SourceMapSource.js
// module id = 4135
// module chunks = 0